module.exports = __webpack_public_path__ + "static/media/HS5111HJ.b82494b7.jpg";